import { useMediaQuery } from 'react-responsive';
import { MOBILE_WIDTH } from '~/config';

export function useIsDesktop() {
  const isDesktop = useMediaQuery({ minWidth: MOBILE_WIDTH });
  return isDesktop;
}
